import { render } from "./App.vue?vue&type=template&id=f37f2a4c"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f37f2a4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f37f2a4c', __exports__)) {
    api.reload('f37f2a4c', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=f37f2a4c", () => {
    api.rerender('f37f2a4c', render)
  })

}


export default __exports__